<h3>
  Dental Referrals Response: {{dcoDisplayName}}
</h3>
<div class="table-actions">
  <div class="table-actions-left">
    <mat-form-field class="action-field" appearance="fill">
      <mat-label>Action</mat-label>
      <mat-select [(ngModel)]="currentActionValue" (selectionChange)="onAction($event.value)">
        <mat-option value="" disabled>Select an action</mat-option>
        <mat-option value="Export">Export</mat-option>
        <mat-option value="Close">Close</mat-option>
        <mat-option value="Open">Open</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="search-field" appearance="fill">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="currentSearchValue" placeholder="Member ID, Name, Phone Number or Notes" (input)="onSearch()" />
      <button *ngIf="currentSearchValue" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
        <i class="fa-duotone fa-solid fa-circle-xmark"></i>
      </button>
    </mat-form-field>

    <mat-form-field class="filter-field" appearance="fill">
      <mat-label>Filter</mat-label>
      <mat-select [(ngModel)]="currentFilterSelection" (selectionChange)="onFilterChange()">
        <mat-option *ngIf="currentFilterSelection" value="">(Clear Filter)</mat-option>

        <mat-optgroup label="Source">
          <mat-option value="PCP">PCP Only</mat-option>
          <mat-option value="HRAT">HRAT Only</mat-option>
          <mat-option value="Maternity">Maternity Only</mat-option>
        </mat-optgroup>

        <mat-optgroup label="Review Flags">
          <mat-option value="HasSpokeWith">Has Spoke With</mat-option>
          <mat-option value="HasLeftMessage">Has Left Message</mat-option>
          <mat-option value="HasSentLetter">Has Sent Letter</mat-option>
          <mat-option value="HasScheduledAppointment">Has Scheduled Appointment</mat-option>
          <mat-option value="HasNotes">Has Notes</mat-option>
        </mat-optgroup>

        <mat-optgroup label="Status">
          <mat-option value="STATUS:OPEN">Open Only</mat-option>
          <mat-option value="STATUS:CLOSED">Closed Only</mat-option>
        </mat-optgroup>

        <mat-optgroup label="DCO Notes">
          <mat-option *ngFor="let item of dcoNotesListItems"
                      [value]="'NOTE:' + item.name">
            {{ item.name }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <mat-chip-set class="active-filters" *ngIf="hasActiveFilters()">

      <!-- Search Chip -->
      <mat-chip *ngIf="currentSearchValue && currentSearchValue.length >= 3" removable (removed)="clearSearch()">
        Search: "{{ currentSearchValue }}"
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>

      <!-- Filter Chip -->
      <mat-chip *ngIf="currentFilterSelection" removable (removed)="clearFilter()">
        Filter: {{ displayFilterName(currentFilterSelection) }}
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>

      <!-- Clear All Chip (optional) -->
      <mat-chip *ngIf="(currentSearchValue && currentSearchValue.length >= 3) && currentFilterSelection"
                removable (removed)="resetAllFilters()">
        Clear All
        <button mat-icon-button matChipRemove>
          <i class="fa-duotone fa-solid fa-circle-xmark"></i>
        </button>
      </mat-chip>
    </mat-chip-set>

    <mat-slide-toggle [(ngModel)]="filtersEnabled" (change)="applyFilter()" class="toggle-filter">
      Toggle Filters
    </mat-slide-toggle>

  </div>
  <div class="table-actions-right">
    <!-- Urgent toggle button -->
    <button mat-stroked-button (click)="toggleUrgentOnly()" class="btn-urgent">
      <i class="fa-sharp-duotone fa-triangle-exclamation"></i>
      {{ urgentOnly ? 'Show All' : 'Urgent Only' }}
      <span *ngIf="urgentCount" class="count"> ({{ urgentCount }})</span>
    </button>

    <!-- Existing Show/Hide Closed button -->
    <button mat-stroked-button (click)="toggleShowClosed()">
      <i class="fa-sharp-duotone" [ngClass]="{'fa-eye': showClosed, 'fa-eye-slash': !showClosed}"></i>
      {{ showClosed ? 'Hide Closed' : 'Show Closed' }}
    </button>
  </div>
</div>

<div class="table-wrapper">
  <table mat-table [dataSource]="referralsDataSource" class="mat-elevation-z8" *ngIf="referralsDataSource?.data?.length > 0; else noData" matSort (matSortChange)="onReferralsGridSortChange($event)">

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="isAllSelected()"
                      [indeterminate]="isIndeterminate()"
                      [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let referral">
        <mat-checkbox (click)="$event.stopPropagation()"
                      [checked]="selection.isSelected(referral)"
                      (change)="$event ? selection.toggle(referral) : null"
                      [aria-label]="checkboxLabel(referral)">
        </mat-checkbox>
      </td>
    </ng-container>


    <ng-container matColumnDef="locked">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="locked"> Locked </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <ng-container *ngIf="referral.review?.isLocked">
          <i class="fa-duotone fa-lock"
             [ngClass]="{ 'clickable-lock': canForceUnlock(referral) }"
             [matTooltip]="getLockTooltip(referral, i)"
             matTooltipClass="multiline-tooltip"
             (click)="onLockClick(referral, i)">
          </i>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="memberId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="memberId"> DMAPID </th>
      <td mat-cell *matCellDef="let referral"> {{ referral.memberMedicaidId }} </td>
    </ng-container>

    <ng-container matColumnDef="memberName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="memberName"> Member Name </th>
      <td mat-cell *matCellDef="let referral"> {{ referral.memberFirstName }} {{ referral.memberLastName }}</td>
    </ng-container>

    <ng-container matColumnDef="parent">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="parent"> Parent </th>
      <td mat-cell *matCellDef="let referral"> {{ referral.memberParentOrGuardianName }} </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="phone"> Phone </th>
      <td mat-cell *matCellDef="let referral"> {{ referral.memberPhoneNumber | phoneNumber }} </td>
    </ng-container>

    <ng-container matColumnDef="receivedDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="receivedDate">Received Date</th>
      <td mat-cell *matCellDef="let r">{{ r.receivedDate | date }}</td>
    </ng-container>

    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="source"> Source </th>
      <td mat-cell *matCellDef="let referral"> {{ referral.referralType }}  </td>
    </ng-container>

    <ng-container matColumnDef="spoke">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="spoke"> Spoke with? </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <ng-container *ngIf="(selectedReferral?.id === referral.id && referral.review); else displayValue">
          <mat-checkbox [(ngModel)]="referral.review.spokeWithMember"></mat-checkbox>
        </ng-container>
        <ng-template #displayValue>
          <i *ngIf="referral.review?.spokeWithMember" class="fa-solid fa-check"></i>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="message"> Left message? </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <ng-container *ngIf="(selectedReferral?.id === referral.id && referral.review); else displayValue">
          <mat-checkbox [(ngModel)]="referral.review.leftMessage"></mat-checkbox>
        </ng-container>
        <ng-template #displayValue>
          <i *ngIf="referral.review.leftMessage" class="fa-solid fa-check"></i>
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="letter">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="letter"> Sent letter? </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <ng-container *ngIf="(selectedReferral?.id === referral.id && referral.review); else displayValue">
          <mat-checkbox [(ngModel)]="referral.review.sentLetter"></mat-checkbox>
        </ng-container>
        <ng-template #displayValue>
          <i *ngIf="referral.review.sentLetter" class="fa-solid fa-check"></i>
        </ng-template>
      </td>
    </ng-container>


    <ng-container matColumnDef="apptDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="apptDate"> Appointment Date </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <div class="center-content">
          <ng-container *ngIf="(selectedReferral?.id === referral.id && referral.review); else displayValue">
            <div class="datepicker-container">
              <input matInput class="short-date-picker" [matDatepicker]="apptDatePicker" [(ngModel)]="referral.review.appointmentDate" (dateChange)="onAppointmentDateChange(referral)">
              <mat-datepicker-toggle matSuffix [for]="apptDatePicker"></mat-datepicker-toggle>
            </div>
            <mat-datepicker #apptDatePicker></mat-datepicker>
          </ng-container>
          <ng-template #displayValue>
            {{ referral.review.appointmentDate | date }}
          </ng-template>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="dcoNote">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dcoNote"> DCO Notes </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <ng-container *ngIf="(selectedReferral?.id === referral.id && referral.review); else displayValue">
          <select [(ngModel)]="referral.review.dcoNote">
            <option *ngFor="let item of dcoNotesListItems" [value]="item.name">
              {{ item.name }}
            </option>
          </select>
        </ng-container>
        <ng-template #displayValue>
          {{ referral.review.dcoNote }}
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let referral; let i = index">
        <!-- When the row is not active, show the original action buttons -->
        <ng-container *ngIf="selectedReferral?.id !== referral.id">
          <button *ngIf="!referral.review?.isClosed" mat-icon-button (click)="onEdit(referral, i)">
            <i class="fa-sharp-duotone fa-solid fa-pencil"></i>
          </button>
          <button *ngIf="referral.review?.isClosed" mat-icon-button>
            <i class="fa-sharp-duotone fa-light fa-eye-slash"></i>
          </button>
          <button mat-icon-button (click)="onReProcessAction(referral, i)">
            <i class="fa-duotone fa-solid fa-repeat"></i>
          </button>
          <button mat-icon-button (click)="onInfo(referral, i)">
            <i class="fa-sharp-duotone fa-solid fa-circle-info"></i>
          </button>
        </ng-container>

        <!-- When the row is active, show the save and cancel buttons -->
        <ng-container *ngIf="selectedReferral?.id === referral.id">
          <button mat-icon-button class="save-button" (click)="onSave(referral, i)">
            <i class="fa-sharp-duotone fa-solid fa-check"></i>
          </button>
          <button mat-icon-button class="cancel-button" (click)="onCancel(referral, i)">
            <i class="fa-sharp-duotone fa-solid fa-times"></i>
          </button>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns;"
        [ngClass]="{
          'urgent-row': isUrgent(row),
          'row-closed': row.review?.isClosed,
          'active': selectedReferral?.id === row.id && !row.review?.isClosed
        }"
        (dblclick)="onEdit(row, i)"
        [attr.disabled]="row.review?.isClosed ? '' : null">
    </tr>



  </table>
  <div class="paginator-wrap">
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"
                   aria-label="Select page of referrals"
                   showFirstLastButtons>
    </mat-paginator>

    <!-- overlayed summary; does NOT shrink the paginator -->
    <div class="paginator-overlay" *ngIf="filteredCount() > 0">
      <span class="sel-summary">
        <strong>{{ selectedInFilteredCount() }}</strong> selected / {{ filteredCount() }} total
        <span hidden class="page-summary" *ngIf="pageCount() > 0"> • {{ selectedOnPageCount() }} on this page</span>
      </span>

      <button mat-button
              class="clear-sel clickable"
              *ngIf="selection.hasValue()"
              (click)="selection.clear()">
        Clear selection
      </button>
    </div>
  </div>
  <!-- No Records Template -->
  <ng-template #noData>
    <div class="no-data-message">
      <h4>No records to show</h4>
      <p>There are currently no records available or the applied filter(s) returned no results.</p>
    </div>
  </ng-template>

</div>
